export const dummyOrderDetails = {
  customerAccountId: '0419FD852145381A0S',
  versionId:
    'v0:CicKATgSB0RBVEVNT04aGTIwMjMtMDktMjVUMTc6NTg6MTMtMDQ6MDAKMQoBOBIHREFURU1PThoZMjAyMy0wOS0yNVQxNzo1ODoxMy0wNDowMCIIMDE3NjA2MjEKMQoBOBIHREFURU1PThoZMjAyMy0wOS0yNVQxNzo1ODoxMy0wNDowMCIIMDE3NjA2MjI=',
  userId: '0419FD852149B81A0U',
  orderNumber: 'WM11884317',
  orderNumbers: ['WM11884317'],
  resultsCount: 2,
  grandTotalAmount: 24.24,
  subTotalAmount: 16.88,
  taxTotalAmount: 1.37,
  orderOrigin: 'Online',
  legacyOrderNumber: 0,
  statusDescription: 'Delivered',
  salesDate: '2023-09-25',
  accountIdValue: '0012222225',
  accountIdUsed: '0012222225',
  showReceiptImage: false,
  showBigReceipt: false,
  recptAddedDate: '2023-09-25',
  transactionId: 0,
  registerNumber: 0,
  storeNumber: 8119,
  rewardsDiscountAmount: 0.0,
  otherDiscountAmount: 0.0,
  POJobName: 'WM11884317',
  storeName: 'THE HOME DEPOT',
  paymentMethods: [
    {
      amount: 0.0,
      lastFour: '1111',
      cardType: 'VI',
      creditCardExpDate: '03/2028',
    },
  ],
  statusCode: 105,
  shippingCharge: 0.0,
  deliveryCharge: 0.0,
  createDateTime: '2023-09-25T17:02:55-04:00',
  changeOwner: 'COM',
  fulfillmentOwner: 'COM',
  emailId: 'b2btest2@email.com',
  returnOnlineAllowed: false,
  authDeclined: false,
  purchaserId: '0419FD852149B81A0U',
  bannerMessageType: 'none',
  fulfillmentGroups: [
    {
      fulfillmentType: 'ShipToHome',
      fulfillmentDate: '',
      fulfillmentStore: '8119',
      isComAppliance: false,
      isBossPostShipped: false,
      isPostRemorse: true,
      shippingAndHandling: {
        shipmentModeCode: 'SG',
        shippingDescription: 'Standard Shipping',
        shippingStatus: 'Delivered',
        isCarrierIntegrationAvailable: false,
        comEstEndDeliveryDate: '2023-10-09T00:00:00-04:00',
        deliveryAddress: {
          name: {
            firstName: 'Sugeesh',
            lastName: 'Suresh',
          },
          postalDetails: {
            addressLine1: '121 Paces Run',
            city: 'ATLANTA',
            state: 'GA',
            zipCode: '30339',
            country: 'US',
          },
          phoneNumbers: {
            dayPhone: '1222222500',
            mobilePhone: '1222222500',
          },
        },
        estStartDeliveryDate: '2023-10-09',
        estEndDeliveryDate: '2023-10-09',
        isLineHaul: false,
      },
      lineItems: [
        {
          lineId: '2',
          salesDate: '2023-09-25',
          omsId: 203408110,
          secOmsId: 203408110,
          skuNumber: 1000668009,
          statusDescription: 'Delivered',
          storeNumber: 8119,
          storeName: 'HOMEDEPOT.COM',
          transactionId: 0,
          registerNumber: 0,
          itemDescFromCatalog:
            '4 in. (102mm) Satin Nickel Notched Cabinet Pull',
          POJobName: 'WM11884317',
          departmentName: 'HARDWARE',
          departmentNumber: 25,
          classId: 4,
          className: "BUILDER'S HARDWARE",
          subClassId: 3,
          subClassName: 'CABINET',
          originalUnitPrice: 4.48,
          netUnitPrice: 4.48,
          custProgramDiscAmount: 0.0,
          otherDiscountAmount: 0.0,
          pretaxTotal: 8.96,
          modelNumber: 'P25966C-SN-C',
          brandName: 'Liberty',
          imageUrl:
            'https://images-qa.thdstatic.com/productImages/99f9a8df-b1eb-4128-9ebf-ccfd658d16c8/svn/liberty-drawer-pulls-p25966c-sn-c-64_100.jpg',
          documents: [
            {
              name: 'Warranty',
              url: 'https://www.homedepot.com/catalog/pdfImages/8c/8cd5ec2c-2708-495c-b4c5-822442988bf4.pdf',
            },
            {
              name: 'Installation Guide',
              url: 'https://www.homedepot.com/catalog/pdfImages/1d/1da4b5ce-9fc9-4ba3-ad3a-fcc3625c33aa.pdf',
            },
          ],
          productType: 'MERCHANDISE',
          type: 'Special Order Merchandise',
          statusCode: 105,
          statusUpdatedDate: '',
          vendorNumber: '20917',
          vendorPartNumber: 'P25966C-SN-C',
          vendorName: 'Liberty',
          fulfillmentVendorNumber: '6007',
          PONumber: '01760621',
          upcCode: '885785482568',
          itemWeightUnitOfMeasure: 'LB',
          itemWeight: 0.1,
          scac: '',
          description: '4 in. (102mm) Satin Nickel Notched Cabinet Pull',
          currentQuantity: 2,
          originalOrderedQuantity: 2,
          orginalOrderedQuantity: 2,
          returnWindowEndDate: 'NOT RETURNABLE',
          cancelledQuantity: 0,
          unitPrice: 4.48,
          unitCost: 'rhVRw8lpeK1RwSMNP0uRLXuFtTKuttSNHheL0dHelPA=',
          totalPrice: 8.96,
          pipSeoUrl:
            '/p/Liberty-4-in-102mm-Satin-Nickel-Notched-Cabinet-Pull-P25966C-SN-C/203408110',
          hideSKU: false,
          bossReorderZeroQuantity: false,
          isInstallItem: false,
          isDFCSourced: true,
          accruedToProRewards: 'N',
          accruedToProXtraPaintRewards: 'N',
          accruedToProXtra: 'N',
          preferredDiscFlg: 'N',
          isCOMAppliance: false,
          delayedShipment: false,
          isBossPostShipped: false,
          isGiftCard: false,
          deliveredDateArray: [],
          isBODFS: false,
          isDFS: false,
          actions: {
            buyAgain: true,
            infoAndGuides: true,
            returnOnlineAllowed: false,
            writeAReview: true,
          },
          unitPriceToPrint: 4.48,
          qtyToPrint: 2,
        },
      ],
      actions: {
        isCancelEnabled: false,
        isLineItemCancelEnabled: false,
        returnOnlineAllowed: false,
        isRescheduleEnabled: false,
        isEditDeliveryInstructionsEnabled: false,
        isEditPickupPersonEnabled: false,
        isEditPickupLocationEnabled: false,
      },
    },
    {
      fulfillmentType: 'ShipToHome',
      fulfillmentDate: '',
      fulfillmentStore: '8119',
      isComAppliance: false,
      isBossPostShipped: false,
      isPostRemorse: true,
      shippingAndHandling: {
        shipmentModeCode: 'GA',
        shippingDescription: 'Priority Ground Shipping',
        shippingStatus: 'Delivered',
        isCarrierIntegrationAvailable: false,
        comEstEndDeliveryDate: '2023-09-26T00:00:00-04:00',
        deliveryAddress: {
          name: {
            firstName: 'Sugeesh',
            lastName: 'Suresh',
          },
          postalDetails: {
            addressLine1: '121 Paces Run',
            city: 'ATLANTA',
            state: 'GA',
            zipCode: '30339',
            country: 'US',
          },
          phoneNumbers: {
            dayPhone: '1222222500',
            mobilePhone: '1222222500',
          },
        },
        estStartDeliveryDate: '2023-09-26',
        estEndDeliveryDate: '2023-09-26',
        isLineHaul: false,
      },
      lineItems: [
        {
          lineId: '1',
          salesDate: '2023-09-25',
          omsId: 100520849,
          secOmsId: 100520849,
          skuNumber: 1000216955,
          statusDescription: 'Delivered',
          storeNumber: 8119,
          storeName: 'HOMEDEPOT.COM',
          transactionId: 0,
          registerNumber: 0,
          itemDescFromCatalog: '4 ft. Clay Solid Gutter Cover',
          POJobName: 'WM11884317',
          departmentName: 'BLDG. MATERIALS',
          departmentNumber: 22,
          classId: 10,
          className: 'ROOFING',
          subClassId: 19,
          subClassName: 'GUTTER ACCESSORIES',
          originalUnitPrice: 3.96,
          netUnitPrice: 3.96,
          custProgramDiscAmount: 0.0,
          otherDiscountAmount: 0.0,
          pretaxTotal: 13.92,
          modelNumber: '85322',
          brandName: 'Amerimax Home Products',
          imageUrl:
            'https://images-qa.thdstatic.com/productImages/a6019c24-0aff-4aba-8414-bd2f735b0410/svn/amerimax-home-products-gutter-guards-85322-64_100.jpg',
          documents: [
            {
              name: 'Installation Guide',
              url: 'https://www.homedepot.com/catalog/pdfImages/ae/ae09df7a-54eb-4988-a730-53dca940d6e3.pdf',
            },
          ],
          productType: 'MERCHANDISE',
          type: 'Special Order Merchandise',
          statusCode: 105,
          statusUpdatedDate: '',
          vendorNumber: '72790',
          vendorPartNumber: '548832',
          vendorName: 'Amerimax Home Products',
          fulfillmentVendorNumber: '6777',
          PONumber: '01760622',
          upcCode: '049821853013',
          itemWeightUnitOfMeasure: 'LB',
          itemWeight: 1.08,
          scac: '',
          description: '4 ft. Clay Solid Gutter Cover',
          currentQuantity: 2,
          originalOrderedQuantity: 2,
          orginalOrderedQuantity: 2,
          returnWindowEndDate: 'NOT RETURNABLE',
          cancelledQuantity: 0,
          unitPrice: 6.96,
          unitCost: 'A+htv4JDfX/9jSxoDcFHyt2Iu+VRjJzce6YMlXeib6A=',
          totalPrice: 13.92,
          pipSeoUrl:
            '/p/Amerimax-Home-Products-4-ft-Clay-Solid-Gutter-Cover-85322/100520849',
          hideSKU: false,
          bossReorderZeroQuantity: false,
          isInstallItem: false,
          isDFCSourced: true,
          accruedToProRewards: 'N',
          accruedToProXtraPaintRewards: 'N',
          accruedToProXtra: 'N',
          preferredDiscFlg: 'N',
          isCOMAppliance: false,
          delayedShipment: false,
          isBossPostShipped: false,
          isGiftCard: false,
          deliveredDateArray: [],
          isBODFS: false,
          isDFS: false,
          actions: {
            buyAgain: true,
            infoAndGuides: true,
            returnOnlineAllowed: false,
            writeAReview: true,
            trackingEnabled: false,
          },
          unitPriceToPrint: 3.96,
          qtyToPrint: 2,
        },
      ],
      actions: {
        isCancelEnabled: false,
        isLineItemCancelEnabled: false,
        returnOnlineAllowed: false,
        isRescheduleEnabled: false,
        isEditDeliveryInstructionsEnabled: false,
        isEditPickupPersonEnabled: false,
        isEditPickupLocationEnabled: false,
      },
    },
  ],
  invoiceNumbers: [],
  tenders: [
    {
      value: '1111',
      type: 'VI',
      amount: '-24.2400',
    },
  ],
  isGiftCardPerksUsed: false,
  preferredDiscFlg: 'N',
  net: 'k+PAe1efCn2uqZoowjL4WRlIYYBgk5p0BAHP/iHc31FTPk4dUaB8qdoFe39lIh9Y4Uz1rJSLCYBIoZFT4VOQ9qAviMRHDvuAlZntVIcizM0z4BoEfwj+a8XU7A+8BYbWFktRJF74V+7mQ1bB3kUOHBebfVcXSiV1FCBVm8L7rig3saCn7Ia7rzQzUko7IrRzZkmJQxq+2RjRiadkFt3TRkoAFXyY4GmsTawpr3goDVqqBj8C2fpTTitxZ2wmuJaQ0+0w7+pTYbMPw+i6/+1PNopY4iVgxOVz/wqRdI0NjthAh8BqA52+pOXslxkTvNda',
  returnTotal: 0.0,
  billingAddress: {
    addrIdentifier: 0,
    emailId: 'b2btest2@email.com',
    name: {
      firstName: 'Sugeesh',
      lastName: 'Suresh',
    },
    postalDetails: {
      addressLine1: '121 Paces Run',
      city: 'ATLANTA',
      state: 'GA',
      zipCode: '30339',
      country: 'US',
    },
    primaryPhone: {
      number: '1222222500',
    },
  },
  isDFCSourced: true,
  storeDetails: {},
  cancellationRequested: false,
  actions: {
    returnOnlineAllowed: false,
    isDFSRescheduleEnabled: false,
  },
  chargeTransactions: [],
  isInLocker: false,
};
